// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Indentation: */
p.quarter {
  text-indent: 0.25in;
}
p.half {
  text-indent: 0.5in;
}
p.three-quarters {
  text-indent: 0.75in;
}
p.one {
  text-indent: 1in;
}

/* Cursor Visibility: */
#default {
  cursor: default;
}
#one {
  cursor: none;
}

.a-continuous-flow-of-introductions {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50vw;
  height: 90vh;
  padding: 5vh 45vw 5vh 5vw;
}
.a-continuous-flow-of-introductions div.stanza {
  line-height: 0.9;
}
.a-continuous-flow-of-introductions div.top-margin {
  margin-top: 28px;
}

.The-crowd-presses-me {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50vw;
  height: 50vh;
  padding: 25vh 25vw;
}

.I-laugh-at-my-fierce-guest {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50vw;
  height: 50vh;
  padding: 25vh 45vw 25vh 5vw;
  line-height: 10px;
}

.Prestigious-ghosts {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50vw;
  height: 90vh;
  padding: 5vh 45vw 5vh 5vw;
  line-height: 0.5;
}

.Pictorial-preoccupations {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50vw;
  height: 50vh;
  padding: 25vh 45vw 25vh 5vw;
  line-height: 1;
}

.Hunters-behind-clouds {
  position: absolute;
  width: 50vw;
  height: 50vh;
  padding: 7vh 45vw 43vh 5vw;
}

.The-body-delighted {
  position: absolute;
  width: 50vw;
  height: 55vh;
  padding: 41vh 43vw 4vh 7vw;
  line-height: 0.6;
}

.Regent-of-Interregnum {
  position: absolute;
  bottom: 0%;
  width: 50vw;
  height: 40vh;
  padding: 59vh 45vw 1vh 5vw;
  line-height: 0.6;
}

.I-am-the-inheritor {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 485px;
  height: 50vh;
  padding: 25vh calc(100vw - 970px);
  text-align: justify;
  white-space: normal;
}

.Parched-spirits {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20vw;
  height: 90vh;
  padding: 5vh 75vw 5vh 5vw;
  line-height: 0.8;
}

.You-must-have-regard {
  position: absolute;
  width: 440px;
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: calc(100vw - 440px);
  text-align: justify;
  white-space: normal;
}

.By-itself-time {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 8vw;
  column-gap: 8vw;
  grid-row-gap: 3vh;
  row-gap: 3vh;
  width: 28vw;
  height: 32vh;
  padding: 32.5vh 33vw;
}
.By-itself-time > div.stanza {
  line-height: 0.5;
}

.scud-angel {
  position: absolute;
  right: 0%;
  width: 50vw;
  height: 60vh;
  padding: 7vh 6vw 33vh 46vw;
  text-align: right;
  line-height: 1;
}
.scud-angel > p.top-margin {
  margin-top: 40px;
}

.Dear-Doctor {
  position: absolute;
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  white-space: normal;
  line-height: 0.6;
}

.What-are-we-to-do-with {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: -webkit-max-content;
  width: max-content;
  max-width: 90vw;
  overflow-x: auto;
  white-space: pre;
  line-height: 1.5;
}
.What-are-we-to-do-with div.centered-italic {
  text-align: center;
}

@media (max-width: 800px) {
  .What-are-we-to-do-with p {
    position: static;
    top: auto;
    left: auto;
    transform: none;
    white-space: pre;
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/poem-styles/sub-poems.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,gCAAgC;EAChC,oBAAe;EAAf,eAAe;EACf,iBAAY;EAAZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,0BAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* Indentation: */\np.quarter {\n  text-indent: 0.25in;\n}\np.half {\n  text-indent: 0.5in;\n}\np.three-quarters {\n  text-indent: 0.75in;\n}\np.one {\n  text-indent: 1in;\n}\n\n/* Cursor Visibility: */\n#default {\n  cursor: default;\n}\n#one {\n  cursor: none;\n}\n\n.a-continuous-flow-of-introductions {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50vw;\n  height: 90vh;\n  padding: 5vh 45vw 5vh 5vw;\n}\n.a-continuous-flow-of-introductions div.stanza {\n  line-height: 0.9;\n}\n.a-continuous-flow-of-introductions div.top-margin {\n  margin-top: 28px;\n}\n\n.The-crowd-presses-me {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 50vw;\n  height: 50vh;\n  padding: 25vh 25vw;\n}\n\n.I-laugh-at-my-fierce-guest {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50vw;\n  height: 50vh;\n  padding: 25vh 45vw 25vh 5vw;\n  line-height: 10px;\n}\n\n.Prestigious-ghosts {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50vw;\n  height: 90vh;\n  padding: 5vh 45vw 5vh 5vw;\n  line-height: 0.5;\n}\n\n.Pictorial-preoccupations {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50vw;\n  height: 50vh;\n  padding: 25vh 45vw 25vh 5vw;\n  line-height: 1;\n}\n\n.Hunters-behind-clouds {\n  position: absolute;\n  width: 50vw;\n  height: 50vh;\n  padding: 7vh 45vw 43vh 5vw;\n}\n\n.The-body-delighted {\n  position: absolute;\n  width: 50vw;\n  height: 55vh;\n  padding: 41vh 43vw 4vh 7vw;\n  line-height: 0.6;\n}\n\n.Regent-of-Interregnum {\n  position: absolute;\n  bottom: 0%;\n  width: 50vw;\n  height: 40vh;\n  padding: 59vh 45vw 1vh 5vw;\n  line-height: 0.6;\n}\n\n.I-am-the-inheritor {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 485px;\n  height: 50vh;\n  padding: 25vh calc(100vw - 970px);\n  text-align: justify;\n  white-space: normal;\n}\n\n.Parched-spirits {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20vw;\n  height: 90vh;\n  padding: 5vh 75vw 5vh 5vw;\n  line-height: 0.8;\n}\n\n.You-must-have-regard {\n  position: absolute;\n  width: 440px;\n  height: auto;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: calc(100vw - 440px);\n  text-align: justify;\n  white-space: normal;\n}\n\n.By-itself-time {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: grid;\n  grid-template-columns: auto auto;\n  column-gap: 8vw;\n  row-gap: 3vh;\n  width: 28vw;\n  height: 32vh;\n  padding: 32.5vh 33vw;\n}\n.By-itself-time > div.stanza {\n  line-height: 0.5;\n}\n\n.scud-angel {\n  position: absolute;\n  right: 0%;\n  width: 50vw;\n  height: 60vh;\n  padding: 7vh 6vw 33vh 46vw;\n  text-align: right;\n  line-height: 1;\n}\n.scud-angel > p.top-margin {\n  margin-top: 40px;\n}\n\n.Dear-Doctor {\n  position: absolute;\n  height: auto;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  white-space: normal;\n  line-height: 0.6;\n}\n\n.What-are-we-to-do-with {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: max-content;\n  max-width: 90vw;\n  overflow-x: auto;\n  white-space: pre;\n  line-height: 1.5;\n}\n.What-are-we-to-do-with div.centered-italic {\n  text-align: center;\n}\n\n@media (max-width: 800px) {\n  .What-are-we-to-do-with p {\n    position: static;\n    top: auto;\n    left: auto;\n    transform: none;\n    white-space: pre;\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
